import { CardData, UserData } from "../../constants/GlobalTypesAndEnumsAndConstants";

export type CardRatingSubmission = {
  card: CardData;
  answer: string;
  understandingRating: number;
};

export function buildUpdatedUserRatingsForCard({
  card,
  user,
  answer,
  understandingRating,
  isDailyReview,
  ratedAt,
}: CardRatingSubmission & {
  user: UserData | undefined;
  isDailyReview: boolean;
  ratedAt: Date;
}) {
  const ratingOwnerId = user?.id || "undefined";
  const existingUserRatings: any = card.understanding_ratings_for_card_by_user?.[ratingOwnerId] || {};
  const newRating = {
    date_rated: ratedAt,
    understanding_rating: understandingRating,
    spaced_repetition_id_of_knowledge_rating: isDailyReview
      ? (user?.current_spaced_repetition_review?.id ?? null)
      : null,
  };
  const updatedUserRatings: any = {
    most_recent_date_rated: ratedAt,
    most_recent_answer: answer || existingUserRatings.most_recent_answer || null,
    understanding_ratings_history_object_list: [
      ...(existingUserRatings.understanding_ratings_history_object_list || []),
      newRating,
    ],
  };

  if (existingUserRatings.most_recent_knowledge_understanding_rating) {
    updatedUserRatings.most_recent_knowledge_understanding_rating =
      existingUserRatings.most_recent_knowledge_understanding_rating;
  }
  if (existingUserRatings.most_recent_spaced_repetition_knowledge_rating) {
    updatedUserRatings.most_recent_spaced_repetition_knowledge_rating =
      existingUserRatings.most_recent_spaced_repetition_knowledge_rating;
    updatedUserRatings.most_recent_spaced_repetition_id_of_knowledge_rating =
      existingUserRatings.most_recent_spaced_repetition_id_of_knowledge_rating ?? null;
  }

  if (isDailyReview) {
    updatedUserRatings.most_recent_spaced_repetition_knowledge_rating = understandingRating;
    updatedUserRatings.most_recent_spaced_repetition_id_of_knowledge_rating =
      user?.current_spaced_repetition_review?.id ?? null;
  } else {
    updatedUserRatings.most_recent_knowledge_understanding_rating = understandingRating;
  }

  return updatedUserRatings;
}
